module.exports = __webpack_public_path__ + "public/images/schedule/schedule-pattern-2.1ab60fec9e0b5a0a14adb8a2b402e6fb.png";